import MyTimesheet from "../components/MyTimesheet";
import useMyTimesheet from "../hooks/useMyTimesheet";

const MyTimesheetPage = () => {
    const useMyTimesheetProps = useMyTimesheet();
    return (
        <MyTimesheet {...useMyTimesheetProps} />
    )
}

export default MyTimesheetPage;